import * as actions from './bankStatement/actions'
import * as mutations from './bankStatement/mutations'
import * as getters from './bankStatement/getters'

const state = {
    list: [],
    nav: {
        page_number: 1, 
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.transaction_date',
        sort_direction: 0, 
        date_range: [new Date(), new Date()],
        bank_id: 0,
        store_id: 0
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/bankStatement.js